import React from "react"
import "../../styles/Common/CircleIcon.less"
import Image from "./Image"
export default function CircleIcon({ iconStyle = "DefaultCircleIcon", defer = true, ...props }) {
  return <Image defer={defer} className={iconStyle} alt={""} src={`assets/${props.iconUrl}.svg`} onClick={props.onClick} />
}
